import { forwardRef, type HTMLAttributes } from 'react';
import styles from './Card.module.css';
import { cx } from '../../lib/cx';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: 'none' | 'sm' | 'md' | 'lg';
  highlight?: boolean;
  interactive?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { padding = 'md', highlight, interactive, className, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cx(
        styles.card,
        padding === 'sm' && styles['pad-sm'],
        padding === 'lg' && styles['pad-lg'],
        padding === 'none' && styles['pad-none'],
        highlight && styles.highlight,
        interactive && styles.interactive,
        className,
      )}
      {...rest}
    />
  );
});
